// The site's language, not the browser's: a Dutch page says "gisteren", whoever reads it.
// The clock stays the visitor's own time zone.
const siteLocale = (): string | undefined => document.documentElement.lang || undefined;

const formatMessageDate = (element: HTMLTimeElement): void => {
  const dateTimeStr = element.getAttribute("datetime");
  if (!dateTimeStr) return;

  const date = new Date(dateTimeStr);
  const now = new Date();

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const messageDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const diffDays = Math.round((today.getTime() - messageDay.getTime()) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    element.textContent = new Intl.DateTimeFormat(siteLocale(), { timeStyle: "short" }).format(
      date,
    );
  } else if (diffDays === 1) {
    element.textContent = new Intl.RelativeTimeFormat(siteLocale(), { numeric: "auto" }).format(
      -1,
      "day",
    );
  } else if (diffDays < 7) {
    element.textContent = new Intl.DateTimeFormat(siteLocale(), { weekday: "long" }).format(date);
  } else {
    element.textContent = new Intl.DateTimeFormat(siteLocale(), { dateStyle: "short" }).format(
      date,
    );
  }
};

export const formatMessageTimes = (container: Element | Document = document): void => {
  container.querySelectorAll<HTMLTimeElement>("time.message-time").forEach(formatMessageDate);
};

export const initTimeFormat = () => {
  /**
   * Format <time></time> HTML title to browser local time, in the site's language
   */
  document.querySelectorAll("time").forEach((element) => {
    const dateTimeStr = element.getAttribute("datetime") as string;
    const dateTime = new Date(dateTimeStr);

    const dateFormat = new Intl.DateTimeFormat(siteLocale(), {
      dateStyle: "full",
      timeStyle: "short",
    }).format(dateTime);

    element.setAttribute("title", dateFormat);
  });

  formatMessageTimes();
};
